import React from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import DynamicBreadcrumbs from "../../../../../elements/v2/DynamicBreadcrumbs/DynamicBreadcrumbs";
import { Typography } from "@ann/web-components";
import { BreadcrumbContainer, CustomBreadcrumbWrapper } from "./Breadcrumb.styled";
import { useStore } from "../../../../../hooks";
import { observer } from "mobx-react";

const Breadcrumb = observer(({ agentName, hasUnsavedChanges, saveImmediately }) => {
  const { agentId } = useParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { playgroundConfigStore } = useStore();
  const { agentStore } = playgroundConfigStore;

  const handleNavigate = (href) => {
    // Save changes before navigating
    if (hasUnsavedChanges && saveImmediately) {
      saveImmediately();
    }
    navigate(href);
  };

  const items = [{ label: 'Agents', href: '/v2/agentsView' }];
  
  if (agentId) {   
    items.push({
      label: agentStore.name || "Agent Name",
    });
  }

  return (
    <BreadcrumbContainer>
      <CustomBreadcrumbWrapper>
        <DynamicBreadcrumbs 
          items={items} 
          currentPath={pathname}
          onNavigate={handleNavigate}
        />
      </CustomBreadcrumbWrapper>
    </BreadcrumbContainer>
  );
});

export default Breadcrumb;
